import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  connect() {
    this.activeTabClasses = (this.data.get('activeTab') || 'active').split(' ')
    this.inactiveTabClasses = (this.data.get('inactiveTab') || 'inactive').split(' ')
    if (this.anchor){
      if (this.anchor.match("part") || this.anchor.match("bottom")) {
        const part = this.anchor
        //work-around upstream stimulus bug in dispatch on connect
        setTimeout(() =>{
          this.dispatch("slupdate", { detail: { content: part } })
          document.execCommand("slupdate")
        },1);

        this.index = this.tabTargets.findIndex((tab) => tab.id === 'interview')
      } else {
        this.index = this.tabTargets.findIndex((tab) => tab.id === this.anchor)
      }
    }
    this.showTab()
  }

  change(event) {
    event.preventDefault()

    let tabName = event.currentTarget.innerText
    let tabFormButtons = Array.from(document.getElementsByClassName('tabFormButton'))

    tabFormButtons.forEach(el => { el.classList.add("hidden") })
    if(document.getElementsByClassName(tabName)[0]){
      document.getElementsByClassName(tabName)[0].classList.remove('hidden')
    }

    // If target specifies an index, use that
    if (event.currentTarget.dataset.index) {
      this.index = event.currentTarget.dataset.index

    // If target specifies an id, use that
    } else if (event.currentTarget.dataset.id) {
      this.index = this.tabTargets.findIndex((tab) => tab.id == event.currentTarget.dataset.id)

    // Otherwise, use the index of the current target
    } else {
      this.index = this.tabTargets.indexOf(event.currentTarget)
    }

    // https://github.com/excid3/tailwindcss-stimulus-components/pull/32
    window.dispatchEvent(new CustomEvent('tsc:tab-change'))
    
    // Dispatch a custom event for Kaltura controller to listen to
    const linkEl = event.currentTarget.querySelector('a')
    if (linkEl && linkEl.dataset.segment && linkEl.dataset.chapter) {
      const chapterEvent = new CustomEvent('tabs:chapter-change', { 
        detail: { 
          segment: parseInt(linkEl.dataset.segment), 
          chapter: parseInt(linkEl.dataset.chapter) 
        },
        bubbles: true
      })
      this.element.dispatchEvent(chapterEvent)
    }
  }

  showTab() {
    this.tabTargets.forEach((tab, index) => {
      const panel = this.panelTargets[index]

      if (index === this.index) {
        panel.classList.remove('hidden')
        tab.classList.remove(...this.inactiveTabClasses)
        tab.classList.add(...this.activeTabClasses)

        // Update URL with the tab ID if it has one
        // This will be automatically selected on page load
        if (tab.id) {
          location.hash = tab.id
        }
      } else {
        panel.classList.add('hidden')
        tab.classList.remove(...this.activeTabClasses)
        tab.classList.add(...this.inactiveTabClasses)
      }
    })
  }

  updateScrollPosition() {
    window.scrollTo(0, 0)
  }

  get index() {
    return parseInt(this.data.get('index') || 0)
  }

  set index(value) {
    this.data.set('index', (value >= 0 ? value : 0))
    this.showTab()
  }

  get anchor() {
    return (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
  }
}
